export default __webpack_public_path__ + "static/media/Reset_Icon.d36fd07a.png";